import React, { useRef, useState, useEffect } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { DrainFieldInstallationInspectionInput, schema, DrainFieldInstallationInspectionFormProps, ComplianceData, DrainfieldProductMakeData, DrainfieldProductModelData } from "./DrainFieldInstallationInspectionForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { constants } from "buffer";
import { toast } from "react-toastify";
import { InspectionStatusInput, FinalInspectionPrePopulate } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import { number } from "yup";
// import { usePrettyPrintedState } from './usePrettyPrintedState'


export const DrainfieldInstallationInspectionForm = (props: DrainFieldInstallationInspectionFormProps) => {
    const history = useHistory();
    const path = usePath();
    const { state }: any = useLocation();
    const applicationNumber = state.applicationNumber;
    const lastInspectionStatusData = state.lastInspectionStatusData;
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const drainfieldProductMakeData = useData<DrainfieldProductMakeData[]>("DrainfieldProductMake") || [];
    const drainfieldProductModelData = useData<DrainfieldProductModelData[]>("DrainfieldProductModel") || [];
    const config = useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];

    const user = useProfile(application) as UserSecurityInput;
    const [isDrainfield2Showable, setIsDrainfield2Showable] = useState(
        (props.values as any)?.isDrainfield2Showable ?? (
            !!props.values?.drainfield2AreaComplianceId ||
            !!(props.values as any)?.drainfield2NumberOfUnits
        )
    );
    const { control, handleSubmit, setValue, watch, reset, getValues } = useForm<DrainFieldInstallationInspectionInput>({
        defaultValues: {
            ...props.values,
            isDrainfield2Showable: (props.values as any)?.isDrainfield2Showable ?? (
                !!props.values?.drainfield2AreaComplianceId ||
                !!(props.values as any)?.drainfield2NumberOfUnits
            ),
            // Ensure all drainfield2 fields are properly initialized from props.values
            drainfield2Area: (props.values as any)?.drainfield2Area ?? undefined,
            drainfield2AreaComplianceId: (props.values as any)?.drainfield2AreaComplianceId || 0,
            drainfield2AreaComment: (props.values as any)?.drainfield2AreaComment || '',
            drainfield2DistributionComplianceId: (props.values as any)?.drainfield2DistributionComplianceId || 0,
            drainfield2DistributionComment: (props.values as any)?.drainfield2DistributionComment || '',
            drainfield2DistributionBoxOrHeader: (props.values as any)?.drainfield2DistributionBoxOrHeader || 0,
            drainfield2NumberOfDrainlinesComplianceId: (props.values as any)?.drainfield2NumberOfDrainlinesComplianceId || 0,
            drainfield2NumberOfDrainlinesComment: (props.values as any)?.drainfield2NumberOfDrainlinesComment || '',

            drainfield2NumberOfDrainline: (props.values as any)?.drainfield2NumberOfDrainline ?? undefined,
            drainfield2NumberOfUnits: (props.values as any)?.drainfield2NumberOfUnits ?? undefined,
            drainfield2DrainlineSeparationComplianceId: (props.values as any)?.drainfield2DrainlineSeparationComplianceId || 0,
            drainfield2DrainlineSeparationComment: (props.values as any)?.drainfield2DrainlineSeparationComment || '',
            drainfield2DrainlineSeparationBedOrTrench: (props.values as any)?.drainfield2DrainlineSeparationBedOrTrench || 0,
            drainfield2DrainlineSlopeComplianceId: (props.values as any)?.drainfield2DrainlineSlopeComplianceId || 0,
            drainfield2DrainlineSlopeComment: (props.values as any)?.drainfield2DrainlineSlopeComment || '',
            drainfield2DepthOfCoverComplianceId: (props.values as any)?.drainfield2DepthOfCoverComplianceId || 0,
            drainfield2DepthOfCoverComment: (props.values as any)?.drainfield2DepthOfCoverComment || '',
            drainfield2ElevationComplianceId: (props.values as any)?.drainfield2ElevationComplianceId || 0,
            drainfield2ElevationComment: (props.values as any)?.drainfield2ElevationComment || '',
            drainfield2Elevation: (props.values as any)?.drainfield2Elevation ?? undefined,
            drainfield2ElevationBenchmark: (props.values as any)?.drainfield2ElevationBenchmark || '',
            drainfield2SystemLocationComplianceId: (props.values as any)?.drainfield2SystemLocationComplianceId || 0,
            drainfield2SystemLocationComment: (props.values as any)?.drainfield2SystemLocationComment || '',
            drainfield2DosingPumpComplianceId: (props.values as any)?.drainfield2DosingPumpComplianceId || 0,
            drainfield2DosingPumpComment: (props.values as any)?.drainfield2DosingPumpComment || '',
            drainfield2DosingPump: (props.values as any)?.drainfield2DosingPump ?? undefined,
            drainfield2AggregateSizeComplianceId: (props.values as any)?.drainfield2AggregateSizeComplianceId || 0,
            drainfield2AggregateSizeComment: (props.values as any)?.drainfield2AggregateSizeComment || '',
            drainfield2AggregateExcessiveComplianceId: (props.values as any)?.drainfield2AggregateExcessiveComplianceId || 0,
            drainfield2AggregateExcessiveComment: (props.values as any)?.drainfield2AggregateExcessiveComment || '',
            drainfield2AggregateDepthComplianceId: (props.values as any)?.drainfield2AggregateDepthComplianceId || 0,
            drainfield2AggregateDepthComment: (props.values as any)?.drainfield2AggregateDepthComment || '',
            drainfield2DrainfieldTypeComplianceId: (props.values as any)?.drainfield2DrainfieldTypeComplianceId || 0,
            drainfield2DrainfieldTypeComment: (props.values as any)?.drainfield2DrainfieldTypeComment || '',
            drainfield2DrainfieldProductMakeId: (props.values as any)?.drainfield2DrainfieldProductMakeId || 0,
            drainfield2DrainfieldProductModelId: (props.values as any)?.drainfield2DrainfieldProductModelId || 0
        },
        resolver: yupResolver(schema),

    });

	// Ensure form populates when values load asynchronously
	useEffect(() => {
		if (props.values) {
			reset({
				...props.values,
				isDrainfield2Showable: (props.values as any)?.isDrainfield2Showable ?? (
					!!props.values?.drainfield2AreaComplianceId ||
					!!(props.values as any)?.drainfield2NumberOfUnits
				),
				// DF1 Number of Units
				numberOfUnits: (props.values as any)?.numberOfUnits ?? 0,
				// DF2 fields
				drainfield2Area: (props.values as any)?.drainfield2Area ?? undefined,
				drainfield2AreaComplianceId: (props.values as any)?.drainfield2AreaComplianceId ?? 0,
				drainfield2AreaComment: (props.values as any)?.drainfield2AreaComment ?? '',
				drainfield2DistributionComplianceId: (props.values as any)?.drainfield2DistributionComplianceId ?? 0,
				drainfield2DistributionComment: (props.values as any)?.drainfield2DistributionComment ?? '',
				drainfield2DistributionBoxOrHeader: (props.values as any)?.drainfield2DistributionBoxOrHeader ?? 0,
				drainfield2NumberOfDrainlinesComplianceId: (props.values as any)?.drainfield2NumberOfDrainlinesComplianceId ?? 0,
				drainfield2NumberOfDrainlinesComment: (props.values as any)?.drainfield2NumberOfDrainlinesComment ?? '',
				drainfield2NumberOfDrainline: (props.values as any)?.drainfield2NumberOfDrainline ?? undefined,
				drainfield2NumberOfUnits: (props.values as any)?.drainfield2NumberOfUnits ?? undefined,
				drainfield2DrainlineSeparationComplianceId: (props.values as any)?.drainfield2DrainlineSeparationComplianceId ?? 0,
				drainfield2DrainlineSeparationComment: (props.values as any)?.drainfield2DrainlineSeparationComment ?? '',
				drainfield2DrainlineSeparationBedOrTrench: (props.values as any)?.drainfield2DrainlineSeparationBedOrTrench ?? 0,
				drainfield2DrainlineSlopeComplianceId: (props.values as any)?.drainfield2DrainlineSlopeComplianceId ?? 0,
				drainfield2DrainlineSlopeComment: (props.values as any)?.drainfield2DrainlineSlopeComment ?? '',
				drainfield2DepthOfCoverComplianceId: (props.values as any)?.drainfield2DepthOfCoverComplianceId ?? 0,
				drainfield2DepthOfCoverComment: (props.values as any)?.drainfield2DepthOfCoverComment ?? '',
				drainfield2ElevationComplianceId: (props.values as any)?.drainfield2ElevationComplianceId ?? 0,
				drainfield2ElevationComment: (props.values as any)?.drainfield2ElevationComment ?? '',
				drainfield2Elevation: (props.values as any)?.drainfield2Elevation ?? undefined,
				drainfield2ElevationBenchmark: (props.values as any)?.drainfield2ElevationBenchmark ?? '',
				drainfield2SystemLocationComplianceId: (props.values as any)?.drainfield2SystemLocationComplianceId ?? 0,
				drainfield2SystemLocationComment: (props.values as any)?.drainfield2SystemLocationComment ?? '',
				drainfield2DosingPumpComplianceId: (props.values as any)?.drainfield2DosingPumpComplianceId ?? 0,
				drainfield2DosingPumpComment: (props.values as any)?.drainfield2DosingPumpComment ?? '',
				drainfield2DosingPump: (props.values as any)?.drainfield2DosingPump ?? undefined,
				drainfield2AggregateSizeComplianceId: (props.values as any)?.drainfield2AggregateSizeComplianceId ?? 0,
				drainfield2AggregateSizeComment: (props.values as any)?.drainfield2AggregateSizeComment ?? '',
				drainfield2AggregateExcessiveComplianceId: (props.values as any)?.drainfield2AggregateExcessiveComplianceId ?? 0,
				drainfield2AggregateExcessiveComment: (props.values as any)?.drainfield2AggregateExcessiveComment ?? '',
				drainfield2AggregateDepthComplianceId: (props.values as any)?.drainfield2AggregateDepthComplianceId ?? 0,
				drainfield2AggregateDepthComment: (props.values as any)?.drainfield2AggregateDepthComment ?? '',
				drainfield2DrainfieldTypeComplianceId: (props.values as any)?.drainfield2DrainfieldTypeComplianceId ?? 0,
				drainfield2DrainfieldTypeComment: (props.values as any)?.drainfield2DrainfieldTypeComment ?? '',
				drainfield2DrainfieldProductMakeId: (props.values as any)?.drainfield2DrainfieldProductMakeId ?? 0,
				drainfield2DrainfieldProductModelId: (props.values as any)?.drainfield2DrainfieldProductModelId ?? 0,
			});
		}
	}, [props.values, reset]);

	// Keep DF2 visibility in sync when values arrive asynchronously
	useEffect(() => {
		const v: any = props.values || {};
		const shouldShow = v?.isDrainfield2Showable ?? (
			!!v?.drainfield2AreaComplianceId ||
			!!v?.drainfield2NumberOfUnits
		);
		setIsDrainfield2Showable(Boolean(shouldShow));
	}, [props.values]);
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }

    const businessUnits = [{
        id: 0,
        name: "Select D-box or header"
    },
    {
        id: 1,
        name: "D-Box"
    },
    {
        id: 2,
        name: "Header"
    }];
    const businessUnits1 = [
        {
            id: 0,
            name: "Select above or below"
        },
        {
            id: 1,
            name: "Above"
        },
        {
            id: 2,
            name: "Below"
        }];

    const businessUnits2 = [
        {
            id: 0,
            name: "Select bed or trench"
        },
        {
            id: 1,
            name: "Bed"
        },
        {
            id: 2,
            name: "Trench"
        }];

    const onSubmit = useSubmitForm<DrainFieldInstallationInspectionInput>(
        'drainfieldInstallation',
        async (response) => {
            toast.success("Drainfield Installation Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
            if (inspectionStatus == InspectionStatus.Complete) {
                if (inspectionStatusData?.fillExcavationMaterialInspectionId == null
                    || inspectionStatusData?.fillExcavationMaterialInspectionId == undefined) {
                    history.push({
                        pathname: "/fillExcavationMaterial/",
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        state: { lastInspectionStatusData: lastInspectionStatusData, applicationNumber: applicationNumber }

                    })
                }
                else {
                    history.push({
                        pathname: "/fillExcavationMaterial/" + inspectionStatusData?.fillExcavationMaterialId,
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        state: { lastInspectionStatusData: lastInspectionStatusData, applicationNumber: applicationNumber }

                    })
                }
            }
            else if (inspectionStatus == InspectionStatus.Incomplete) {
                history.push({
                    pathname: `/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`,
                    state: { lastInspectionStatusData: lastInspectionStatusData, applicationNumber: applicationNumber }
                });
            }
        },
        props.action
    );


    const submit = () => {
        setValue('applicationId', props.applicationId ? props.applicationId : 0);
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if (inspectionStatusData?.drainfieldInstallationInspectionId == null
            || inspectionStatusData?.drainfieldInstallationInspectionId == undefined) {
            setValue('dateCreated', new Date());
            setValue('createdBy', user?.userName);
        }
        else {
            setValue('dateUpdated', new Date());
            setValue('updatedBy', user?.userName);
        }
        if (formRef.current) {
            setValue('isDrainfield2Showable', isDrainfield2Showable);

            if (!isDrainfield2Showable) {
                setValue('drainfield2AreaComplianceId', 0);
                setValue('drainfield2Area', 0);
                setValue('drainfield2AreaComment', 'Remove Drainfield-2');

                setValue('drainfield2DistributionComplianceId', 0);
                setValue('drainfield2DistributionBoxOrHeader', 0);
                setValue('drainfield2DistributionComment', 'Remove Drainfield-2');

                setValue('drainfield2NumberOfDrainlinesComplianceId', 0);
                setValue('drainfield2NumberOfDrainline', 0);
                setValue('drainfield2NumberOfDrainlinesComment', 'Remove Drainfield-2');

                setValue('drainfield2DrainlineSeparationComplianceId', 0);
                setValue('drainfield2DrainlineSeparationBedOrTrench', 0);
                setValue('drainfield2DrainlineSeparationComment', 'Remove Drainfield-2');

                setValue('drainfield2DrainlineSlopeComplianceId', 0);
                setValue('drainfield2DrainlineSlopeComment', 'Remove Drainfield-2');

                setValue('drainfield2DepthOfCoverComplianceId', 0);
                setValue('drainfield2DepthOfCoverComment', 'Remove Drainfield-2');

                setValue('drainfield2ElevationComplianceId', 0);
                setValue('drainfield2Elevation', 0);
                setValue('drainfield2ElevationBenchmark', '');
                setValue('drainfield2ElevationComment', 'Remove Drainfield-2');

                setValue('drainfield2SystemLocationComplianceId', 0);
                setValue('drainfield2SystemLocationComment', 'Remove Drainfield-2');

                setValue('drainfield2DosingPumpComplianceId', 0);
                setValue('drainfield2DosingPump', 0);
                setValue('drainfield2DosingPumpComment', 'Remove Drainfield-2');

                setValue('drainfield2AggregateSizeComplianceId', 0);
                setValue('drainfield2AggregateSizeComment', 'Remove Drainfield-2');

                setValue('drainfield2AggregateExcessiveComplianceId', 0);
                setValue('drainfield2AggregateExcessiveComment', 'Remove Drainfield-2');

                setValue('drainfield2AggregateDepthComplianceId', 0);
                setValue('drainfield2AggregateDepthComment', 'Remove Drainfield-2');

                // Clear DF2 Number of Units fields
                setValue('drainfield2NumberOfUnits', 0);

                // Clear second drainfield product fields when drainfield2 is not showable
                setValue('drainfield2DrainfieldTypeComplianceId', 0);
                setValue('drainfield2DrainfieldTypeComment', 'Remove Drainfield 2 Product');
                setValue('drainfield2DrainfieldProductMakeId', 0);
                setValue('drainfield2DrainfieldProductModelId', 0);
            }

            formRef.current.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );

        }
    }


    let showAreaComment = watch("areaComplianceId");
    let showDitributionComment = watch("distributionComplianceId");
    let showNumberOfDrainlinesComment = watch("numberOfDrainlinesComplianceId");
    
    let showDrainlineSeparationComment = watch("drainlineSeparationComplianceId");
    let showDrainlineSlopeComment = watch("drainlineSlopeComplianceId");
    let showDepthOfCoverComment = watch("depthOfCoverComplianceId");
    let showElevationComment = watch("elevationComplianceId");
    let showSystemLocationComment = watch("systemLocationComplianceId");
    let showDosingPumpComment = watch("dosingPumpComplianceId");
    let showAggregateSizeComment = watch("aggregateSizeComplianceId");
    let showAggregateExcessiveComment = watch("aggregateExcessiveComplianceId");
    let showAggregateDepthComment = watch("aggregateDepthComplianceId");
    let showDrainLineArea1 = watch("area1");
    let markAllCompliance = watch("markAll");
    let showDrainfield2 = watch("isDrainfield2Showable");
    // Second drainfield watch variables
    let showDrainfield2AreaComment = watch("drainfield2AreaComplianceId");
    let showDrainfield2DistributionComment = watch("drainfield2DistributionComplianceId");
    let showDrainfield2NumberOfDrainlinesComment = watch("drainfield2NumberOfDrainlinesComplianceId");
    let showDrainfield2DrainlineSeparationComment = watch("drainfield2DrainlineSeparationComplianceId");
    let showDrainfield2DrainlineSlopeComment = watch("drainfield2DrainlineSlopeComplianceId");
    let showDrainfield2DepthOfCoverComment = watch("drainfield2DepthOfCoverComplianceId");
    let showDrainfield2ElevationComment = watch("drainfield2ElevationComplianceId");
    let showDrainfield2SystemLocationComment = watch("drainfield2SystemLocationComplianceId");
    let showDrainfield2DosingPumpComment = watch("drainfield2DosingPumpComplianceId");
    let showDrainfield2AggregateSizeComment = watch("drainfield2AggregateSizeComplianceId");
    let showDrainfield2AggregateExcessiveComment = watch("drainfield2AggregateExcessiveComplianceId");
    let showDrainfield2AggregateDepthComment = watch("drainfield2AggregateDepthComplianceId");
    let showDrainfield2DrainLineArea = watch("drainfield2Area");
    // Drainfield Product watch variables
    let showDrainfieldTypeComment = watch("drainfieldTypeComplianceId");
    let drainfieldProductMake = watch("drainfieldProductMakeId");
    const filteredDrainfieldProductModelData = drainfieldProductModelData.filter(x => x.makeId == drainfieldProductMake || x.makeId == 0);
    // Second Drainfield Product watch variables
    let showDrainfield2DrainfieldTypeComment = watch("drainfield2DrainfieldTypeComplianceId");
    let drainfield2DrainfieldProductMake = watch("drainfield2DrainfieldProductMakeId");
    const filteredDrainfield2ProductModelData = drainfieldProductModelData.filter(x => x.makeId == drainfield2DrainfieldProductMake || x.makeId == 0);

    const h1Styles: CSS.Properties = {
        float: "right",
        marginTop: '27px'
    };
    const markClick = (e: any) => {
        //showSerfaceWaterComment = markAllCompliance;
        setValue('areaComplianceId', markAllCompliance);
        setValue('distributionComplianceId', markAllCompliance);
        setValue('numberOfDrainlinesComplianceId', markAllCompliance);
        setValue('drainlineSeparationComplianceId', markAllCompliance);
        setValue('drainlineSlopeComplianceId', markAllCompliance);
        setValue('depthOfCoverComplianceId', markAllCompliance);
        setValue('elevationComplianceId', markAllCompliance);
        setValue('systemLocationComplianceId', markAllCompliance);
        setValue('dosingPumpComplianceId', markAllCompliance);
        setValue('aggregateSizeComplianceId', markAllCompliance);
        setValue('aggregateDepthComplianceId', markAllCompliance);
        setValue('aggregateExcessiveComplianceId', markAllCompliance);
        setValue('drainfieldTypeComplianceId', markAllCompliance);

        // If product is N/A or Unobserved under Mark All, clear product selections
        if (markAllCompliance === Constants.Not_Applicable || markAllCompliance === Constants.Unobserved) {
            setValue('drainfieldProductMakeId', 0);
            setValue('drainfieldProductModelId', 0);
        }

        // Mark all for second drainfield if it's showable
        if (showDrainfield2 == true) {
            setValue('drainfield2AreaComplianceId', markAllCompliance);
            setValue('drainfield2DistributionComplianceId', markAllCompliance);
            setValue('drainfield2NumberOfDrainlinesComplianceId', markAllCompliance);
            setValue('drainfield2DrainlineSeparationComplianceId', markAllCompliance);
            setValue('drainfield2DrainlineSlopeComplianceId', markAllCompliance);
            setValue('drainfield2DepthOfCoverComplianceId', markAllCompliance);
            setValue('drainfield2ElevationComplianceId', markAllCompliance);
            setValue('drainfield2SystemLocationComplianceId', markAllCompliance);
            setValue('drainfield2DosingPumpComplianceId', markAllCompliance);
            setValue('drainfield2AggregateSizeComplianceId', markAllCompliance);
            setValue('drainfield2AggregateExcessiveComplianceId', markAllCompliance);
            setValue('drainfield2AggregateDepthComplianceId', markAllCompliance);
            setValue('drainfield2DrainfieldTypeComplianceId', markAllCompliance);

            if (markAllCompliance === Constants.Not_Applicable || markAllCompliance === Constants.Unobserved) {
                setValue('drainfield2DrainfieldProductMakeId', 0);
                setValue('drainfield2DrainfieldProductModelId', 0);
            }
        }

        e.preventDefault();
    };

    return (
        <form id={props.id} ref={formRef} onSubmit={handleSubmit((data: DrainFieldInstallationInspectionInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Drainfield Installation
                    </div>
                </div>
                <div className="col col-md-3 ms-auto">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>

            <Card.Container>

                <Card.Header>
                    <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>

                        {/* Drainfield Product Section */}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainfieldTypeComplianceId"
                                    label="Alt. Drainfield Product"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainfieldProductMakeId"
                                    label="Drainfield Product Make"
                                    options={drainfieldProductMakeData}
                                    required={showDrainfieldTypeComment != Constants.Not_Applicable && showDrainfieldTypeComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainfieldProductModelId"
                                    label="Drainfield Product Model"
                                    options={filteredDrainfieldProductModelData}
                                    required={showDrainfieldTypeComment != Constants.Not_Applicable && showDrainfieldTypeComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showDrainfieldTypeComment &&
                            showDrainfieldTypeComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainfieldTypeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}


                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="areaComplianceId"
                                    label="Drainfield Area"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="area1"
                                    label="Area (Sq.ft)"
                                    required={showAreaComment != Constants.Not_Applicable && showAreaComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showAreaComment &&
                            showAreaComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="areaComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="distributionComplianceId"
                                    label="Distribution Box"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="distributionBoxOrHeader"
                                    label="Is it a box or header?"
                                    options={businessUnits}
                                    required={showDitributionComment != Constants.Not_Applicable && showDitributionComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showDitributionComment &&
                            showDitributionComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="distributionComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="numberOfDrainlinesComplianceId"
                                    label="Number of Drainlines"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="numberOfDrainline1"
                                    label="Number of Drainlines"
                                    required={showNumberOfDrainlinesComment != Constants.Not_Applicable && showNumberOfDrainlinesComment != Constants.Unobserved && showDrainLineArea1 > 0}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="numberOfUnits"
                                    label="Number of Units"
                                    required={showNumberOfDrainlinesComment != Constants.Not_Applicable && showNumberOfDrainlinesComment != Constants.Unobserved && showDrainLineArea1 > 0}
                                />
                            </div>
                        </div>
                        {showNumberOfDrainlinesComment &&
                            showNumberOfDrainlinesComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="numberOfDrainlinesComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSeparationComplianceId"
                                    label="Drainline Separation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSeparationBedOrTrench"
                                    label="Is it a Bed or Trench?"
                                    options={businessUnits2}
                                    required={showDrainlineSeparationComment != Constants.Not_Applicable && showDrainlineSeparationComment != Constants.Unobserved}
                                />
                            </div>

                        </div>
                        {showDrainlineSeparationComment &&
                            showDrainlineSeparationComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainlineSeparationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSlopeComplianceId"
                                    label="Drainline Slope"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showDrainlineSlopeComment &&
                            showDrainlineSlopeComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainlineSlopeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="depthOfCoverComplianceId"
                                    label="Depth of Absorption Surface"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showDepthOfCoverComment &&
                            showDepthOfCoverComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="depthOfCoverComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="elevationComplianceId"
                                    label="Elevation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="elevation1"
                                    label="Elevation (inches)"
                                    required={showElevationComment != Constants.Not_Applicable && showElevationComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="elevationBenchmark"
                                    label="Above or below benchmark?"
                                    options={businessUnits1}
                                    required={showElevationComment != Constants.Not_Applicable && showElevationComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showElevationComment &&
                            showElevationComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="elevationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="systemLocationComplianceId"
                                    label="Drainfield Location"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showSystemLocationComment &&
                            showSystemLocationComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="systemLocationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="dosingPumpComplianceId"
                                    label="Dosing Pumps"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="dosingPump"
                                    label="Number of Dosing Pumps"
                                    required={showDosingPumpComment != Constants.Not_Applicable && showDosingPumpComment != Constants.Unobserved}
                                />
                            </div>

                        </div>
                        {showDosingPumpComment &&
                            showDosingPumpComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="dosingPumpComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateSizeComplianceId"
                                    label="Mineral Aggregate Size"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateSizeComment &&
                            showAggregateSizeComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateSizeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateExcessiveComplianceId"
                                    label="Mineral Aggregate Excessive Fines"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateExcessiveComment &&
                            showAggregateExcessiveComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateExcessiveComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateDepthComplianceId"
                                    label="Mineral Aggregate Depth"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateDepthComment &&
                            showAggregateDepthComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateDepthComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">

                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                                <FormControl.Hidden
                                    control={control}
                                    name="isDrainfield2Showable"
                                    
                                />
                            </div>


                        </div>

                    </></Layout.Row>
                </Card.Body>

                {/* Add/Remove Second Drainfield Section */}
                <div hidden={isDrainfield2Showable}>
                    <Button id="showme" className="btn btn-primary ms-auto px-3 py-2" onClick={(e) => {
                        e.preventDefault();
                        setIsDrainfield2Showable(true);
                        setValue('isDrainfield2Showable', true);
                    }}>Add Drainfield</Button>
                </div>

                {isDrainfield2Showable && (
                    <Card.Body>
                        {/*  ============================================================================================================================================*/}
                        {/*                                                     Drainfield 2                                                                                   */}
                        {/*  ============================================================================================================================================*/}

                        <div className="row mb-4">
                            <div className="col col-md-8">
                                <div className="d-flex align-items-center">
                                    <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
                                        <span className="fw-bold">2</span>
                                    </div>
                                    <div>
                                        <h3 className="text-primary mb-1 fw-bold">Drainfield 2</h3>
                                        <p className="text-muted mb-0">Additional drainfield installation details</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-md-4 text-end">
                                <Button className="btn btn-danger" onClick={(e) => {
                                    e.preventDefault();
                                    setIsDrainfield2Showable(false);
                                    setValue('isDrainfield2Showable', false);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-trash me-2" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M4 7l16 0"></path>
                                        <path d="M10 11l0 6"></path>
                                        <path d="M14 11l0 6"></path>
                                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                    </svg>
                                    Remove Drainfield
                                </Button>
                            </div>
                        </div>

                        <div className="border-top border-2 border-primary pt-4">
                            <Layout.Row>

                                {/* Drainfield 2 Product Section */}
                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainfieldTypeComplianceId"
                                            label="Alt. Drainfield Product"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainfieldProductMakeId"
                                            label="Drainfield Product Make"
                                            options={drainfieldProductMakeData}
                                            required={showDrainfield2DrainfieldTypeComment != Constants.Not_Applicable && showDrainfield2DrainfieldTypeComment != Constants.Unobserved}
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainfieldProductModelId"
                                            label="Drainfield Product Model"
                                            options={filteredDrainfield2ProductModelData}
                                            required={showDrainfield2DrainfieldTypeComment != Constants.Not_Applicable && showDrainfield2DrainfieldTypeComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DrainfieldTypeComment &&
                                    showDrainfield2DrainfieldTypeComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DrainfieldTypeComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}
                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2AreaComplianceId"
                                            label="Area"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Text
                                            control={control}
                                            name="drainfield2Area"
                                            label="Area (Sq.ft)"
                                            type="number"
                                            required={showDrainfield2AreaComment != Constants.Not_Applicable && showDrainfield2AreaComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2AreaComment &&
                                    showDrainfield2AreaComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2AreaComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DistributionComplianceId"
                                            label="Distribution Box"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DistributionBoxOrHeader"
                                            label="Is it a box or header?"
                                            options={businessUnits}
                                            required={showDrainfield2DistributionComment != Constants.Not_Applicable && showDrainfield2DistributionComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DistributionComment &&
                                    showDrainfield2DistributionComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DistributionComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2NumberOfDrainlinesComplianceId"
                                            label="Number of Drainlines"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Text
                                            control={control}
                                            name="drainfield2NumberOfDrainline"
                                            label="Number of Drainlines"
                                            required={showDrainfield2NumberOfDrainlinesComment != Constants.Not_Applicable && showDrainfield2NumberOfDrainlinesComment != Constants.Unobserved && Number(showDrainfield2DrainLineArea) > 0}
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Text
                                            control={control}
                                            name="drainfield2NumberOfUnits"
                                            label="Number of Units"
                                            required={showDrainfield2NumberOfDrainlinesComment != Constants.Not_Applicable && showDrainfield2NumberOfDrainlinesComment != Constants.Unobserved && Number(showDrainfield2DrainLineArea) > 0}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2NumberOfDrainlinesComment &&
                                    showDrainfield2NumberOfDrainlinesComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2NumberOfDrainlinesComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainlineSeparationComplianceId"
                                            label="Drainline Separation"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainlineSeparationBedOrTrench"
                                            label="Is it a Bed or Trench?"
                                            options={businessUnits2}
                                            required={showDrainfield2DrainlineSeparationComment != Constants.Not_Applicable && showDrainfield2DrainlineSeparationComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DrainlineSeparationComment &&
                                    showDrainfield2DrainlineSeparationComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DrainlineSeparationComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DrainlineSlopeComplianceId"
                                            label="Drainline Slope"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DrainlineSlopeComment &&
                                    showDrainfield2DrainlineSlopeComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DrainlineSlopeComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DepthOfCoverComplianceId"
                                            label="Depth of Absorption Surface"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DepthOfCoverComment &&
                                    showDrainfield2DepthOfCoverComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DepthOfCoverComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2ElevationComplianceId"
                                            label="Elevation"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Text
                                            control={control}
                                            name="drainfield2Elevation"
                                            label="Elevation (inches)"
                                            required={showDrainfield2ElevationComment != Constants.Not_Applicable && showDrainfield2ElevationComment != Constants.Unobserved}
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2ElevationBenchmark"
                                            label="Above or below benchmark?"
                                            options={businessUnits1}
                                            required={showDrainfield2ElevationComment != Constants.Not_Applicable && showDrainfield2ElevationComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2ElevationComment &&
                                    showDrainfield2ElevationComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2ElevationComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2SystemLocationComplianceId"
                                            label="Location"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2SystemLocationComment &&
                                    showDrainfield2SystemLocationComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2SystemLocationComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2DosingPumpComplianceId"
                                            label="Dosing Pumps"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                    <div className="col col-md-4">
                                        <FormControl.Text
                                            control={control}
                                            name="drainfield2DosingPump"
                                            label="Number of Dosing Pumps"
                                            required={showDrainfield2DosingPumpComment != Constants.Not_Applicable && showDrainfield2DosingPumpComment != Constants.Unobserved}
                                        />
                                    </div>
                                </div>
                                {showDrainfield2DosingPumpComment &&
                                    showDrainfield2DosingPumpComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2DosingPumpComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2AggregateSizeComplianceId"
                                            label="Mineral Aggregate Size"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2AggregateSizeComment &&
                                    showDrainfield2AggregateSizeComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2AggregateSizeComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2AggregateExcessiveComplianceId"
                                            label="Mineral Aggregate Excessive Fines"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2AggregateExcessiveComment &&
                                    showDrainfield2AggregateExcessiveComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2AggregateExcessiveComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="row">
                                    <div className="col col-md-4">
                                        <FormControl.Select
                                            control={control}
                                            name="drainfield2AggregateDepthComplianceId"
                                            label="Mineral Aggregate Depth"
                                            options={complianceData}
                                            required
                                        />
                                    </div>
                                </div>
                                {showDrainfield2AggregateDepthComment &&
                                    showDrainfield2AggregateDepthComment == 3 && (
                                        <div className="row">
                                            <div className="col col-md-12">
                                                <FormControl.TextArea
                                                    control={control}
                                                    name="drainfield2AggregateDepthComment"
                                                    label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    )}
                            </Layout.Row>
                        </div>
                    </Card.Body>
                )}

                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()
                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>
                        <div className="btn-list ms-auto">
                            <Link
                                to={{
                                    pathname: props.returnPath ?? path.current,
                                    state: { applicationNumber: applicationNumber },
                                }}
                                className="btn btn-light"
                                role="button">
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()
                            }}>Next</Button>
                        </div>
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};

export default DrainfieldInstallationInspectionForm;




